<template>
    <div>
        <div class="employee-view-tabs mb-4">
            <ul class="nav nav-tabs nav-tabs-2" id="myTab" role="tablist">
                <li class="nav-item" v-if="subscription_fee">
                    <a
                            :class="{ 'nav-link': true, 'active': activeTab === 'company-wise' }"
                            id="reversal-transfer-tab"
                            data-toggle="tab"
                            href="#company-wise"
                            role="tab"
                            aria-controls="company-wise"
                            aria-selected="false"
                            @click="setActiveTab('company-wise')"
                    >
                        Company-Wise Subscription Fee
                    </a>
                </li>
                <li class="nav-item" v-if="subscription_fee_configuration">
                    <a
                            :class="{ 'nav-link': true, 'active': activeTab === 'source-wise' }"
                            id="correction-tab"
                            data-toggle="tab"
                            href="#source-wise"
                            role="tab"
                            aria-controls="loan-amount-ledger-correction"
                            aria-selected="false"
                            @click="setActiveTab('source-wise')"
                    >
                        Source-Wise Subscription Fee
                    </a>
                </li>
            </ul>
        </div>
        <div class="tab-content" id="myTabContent">
            <div
                    v-if="subscription_fee"
                    :class="{ 'tab-pane': true, 'fade': true, 'show': activeTab === 'company-wise', 'active': activeTab === 'company-wise' }"
                    id="company-wise"
                    role="tabpanel"
                    aria-labelledby="company-wise"
            >
                <SubscriptionFee></SubscriptionFee>
            </div>
            <div
                    v-if="subscription_fee_configuration"
                    :class="{ 'tab-pane': true, 'fade': true, 'show': activeTab === 'source-wise', 'active': activeTab === 'source-wise' }"
                    id="source-wise"
                    role="tabpanel"
                    aria-labelledby="loan-amount-ledger-correction"
            >
                <div
                        class="tab-pane fade show active"
                        role="tabpanel"
                        aria-labelledby="source-wise"
                >
                    <SubscriptionFeeConfiguration></SubscriptionFeeConfiguration>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeTab: 'company-wise',
                subscription_fee_configuration: null,
                subscription_fee: null,
            };
        },
        methods: {
            setActiveTab(tab) {
                this.activeTab = tab;
            },
        },
        created() {
            const queryTab = this.$route.query.tab;
            if (queryTab) {
                this.activeTab = queryTab;
            }
        },
        mounted() {
            this.$Progress.start();
            this.can('subscription_fee')
                .then((result) => {
                    this.subscription_fee = result.subscription_fee;
                    this.finishProgress();
                    if (!result.subscription_fee) {
                        this.setActiveTab('source-wise');
                    }
                })
                .catch(this.finishProgress);

            this.can('subscription_fee_configuration')
                .then((result) => {
                    this.subscription_fee_configuration = result.subscription_fee_configuration;
                    this.finishProgress();
                    if (!result.subscription_fee_configuration) {
                        this.setActiveTab('company-wise');
                    }
                })
                .catch(this.finishProgress);
        },
    };
</script>




